import { render, staticRenderFns } from "./companyCallthepolice.vue?vue&type=template&id=835fb85c&"
import script from "./companyCallthepolice.vue?vue&type=script&lang=js&"
export * from "./companyCallthepolice.vue?vue&type=script&lang=js&"
import style0 from "./companyCallthepolice.vue?vue&type=style&index=0&id=835fb85c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports